export enum MiaFormFieldNames {
  CompanyName = 'companyName',
  Phone = 'phone',
  RegistrationNumber = 'registrationNumber',
  Capital = 'capital',
  RcsCity = 'rcsCity',
  RcsNumber = 'rcsNumber',
  OriasNumber = 'oriasNumber',
  Rcp = 'rcp',
  ComplaintEmail = 'complaintEmail',
  /** Sélection {courtierId, tunnelIds[]}[] — paire mandant×tunnel. */
  Mandants = 'mandants',
  FirstName = 'firstName',
  LastName = 'lastName',
  Email = 'email',
  Username = 'username',
  Password = 'password',
  /** Codes référentiels des OUs de rattachement (multi-org : chaque mandant doit
   * partager au moins une de ces plateformes avec le MIA). */
  PlateformeIds = 'plateformeIds',
}
